<template>
  <div>
    <Header class="mb-3" :text="categName" />
    <div v-if="loaded">
      <div :key="$route.params.id">
        <div>
          <h4>
            totale resultaten:
            <span
              class="badge badge-info"
              v-if="pagination.totalResult >= pagination.perPage"
              >{{ pagination.currentPage * pagination.perPage }}/{{
                pagination.totalResult
              }}</span
            >
            <span v-else
              >{{ pagination.totalResult }}/{{ pagination.totalResult }}</span
            >
          </h4>
        </div>
        <div class="products row" v-if="products">
          <ProductCard
            v-for="product in products"
            :key="product.id"
            :product="product"
            class="products__item col-md-4"
          />
        </div>
        <paginate
          :page-count="pagination.totalPage"
          :click-handler="paginatePage"
          :prev-text="'vorige'"
          :next-text="'volgende'"
          v-model="pagination.currentPage"
          :container-class="'pagination'"
        >
        </paginate>
      </div>
    </div>
    <div v-else>
      <div>
        <h2>
          <content-placeholders>
            <content-placeholders-heading style="max-width: 200px" />
            <content-placeholders-text :lines="2" style="max-width: 700px" />
          </content-placeholders>

          <div class="products">
            <div class="row">
              <div class="col-md-4" v-for="i in 9" :key="i">
                <content-placeholders>
                  <content-placeholders-img />
                  <content-placeholders-heading />
                </content-placeholders>
              </div>
            </div>
          </div>
        </h2>
      </div>
    </div>

    <div :key="$route.params.id" class="mb-4 mt-4">
      <div v-if="subCategories.length > 0">
        <h4>Subcategories:</h4>
        <router-link
          :to="`/category/${categ.id}`"
          v-for="categ in subCategories"
          :key="categ.id"
          ><span class="badge badge-success badge-normal mr-2 mb-2">{{
            categ.name
          }}</span></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import WooCommerce from "@/services/wooservice.js";
import ProductCard from "@/components/ProductCard";
import AddingPopupWindow from "@/components/AddingPopupWindow";

export default {
  name: "CategoryPage",
  components: {
    Header,
    ProductCard,
    AddingPopupWindow,
  },
  data() {
    return {
      categName: "",
      loaded: false,
      products: [],
      subCategories: [],
      pagination: {
        perPage: 12,
        currentPage: 1,
        totalPage: 0,
        totalResult: 0,
      },
    };
  },
  methods: {
    getCategoryName(product) {
      product.categories.map((categ) => {
        if (categ.id == this.$route.params.id) {
          this.categName = categ.name;
        }
      });
    },
    getCategoryProducts() {
      let opts = {
        category: this.$route.params.id,
        per_page: this.pagination.perPage,
      };
      if (this.pagination.currentPage > 1) {
        opts.offset =
          (this.pagination.currentPage - 1) * this.pagination.perPage;
      }
      WooCommerce.get("products", opts).then((response) => {
        this.products = response.data;
        if (this.products[0]) {
          this.getCategoryName(this.products[0]);
        }
        this.pagination.totalPage = parseInt(
          response.headers["x-wp-totalpages"]
        );
        this.pagination.totalResult = parseInt(response.headers["x-wp-total"]);
        this.loaded = true;
      });
    },
    paginatePage(opts) {
      this.pagination.currentPage = opts;
      this.loaded = false;
      this.getCategoryProducts();
    },
    getSubCategory() {
      WooCommerce.get("products/categories", {
        parent: this.$route.params.id,
        per_page: 99,
      }).then((response) => {
        this.subCategories = response.data;
      });
    },
  },

  created() {
    this.getCategoryProducts(this.$route.params.id);
    this.getSubCategory();
  },

  beforeRouteUpdate(to, from, next) {
    next();
    this.loaded = false;
    this.currentPage = 1;
    this.getCategoryProducts(this.$route.params.id);
    this.getSubCategory();
  },
};
</script>

<style lang="scss">
.pagination li {
  border: 1px solid #eaeaea;
  padding: 10px 15px;
  margin: 3px;
}
.pagination li.active {
  background: var(--theme);
  color: white;
}
</style>
